import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import './reminderDetail.scss';
const ReminderModal = ({ isOpen, onClose, data }) => {
  const [reminders, setReminders] = useState([]);
  const [expandedItems, setExpandedItems] = useState([]);
  const toggleItem = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  useEffect(() => {
    try {
      if (data) {
        const reminder_obj = JSON.parse(data?.reminder_obj);
        setReminders(reminder_obj.reverse());
      }
    } catch (error) {
      console.error('Error parsing reminder_obj:', error);
      setReminders([]);
    }
    
  }, [data]);
  return (
    <div className={`overlay ${isOpen ? 'active' : ''}`}>
      <div className={`reminderModal ${isOpen ? 'show' : ''}`}>
        {isOpen && <div>
          <div style={styles.headerModal}>
            <span>Details</span>
            <span onClick={onClose} className='closeReminder'><FaTimes /></span>
          </div>
          <div className='reminderModal-data'>
            {reminders.length > 0 ? (
              <div className='d-block'>
                {reminders.map((reminder) => (
                  <div className={expandedItems[reminder.id] ? 'expanded d-block text-start my-3 reminderMain' : 'collapsed d-block text-start my-3 reminderMain'} key={reminder.id}>
                    <div className='d-flex justify-content-between reminderHeader' >
                      <span>Reminder sent</span>
                      <span>
                        <span className='mx-2'>
                          {new Date(
                            reminder?.date_added
                          ).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })}, &nbsp;
                          {new Date(
                            reminder?.date_added
                          ).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true, // <-- This enables AM/PM
                          }).toUpperCase()}
                        </span>
                        <span className='toggleIcon' onClick={() => toggleItem(reminder.id)}>{expandedItems[reminder.id] ? <FaMinus /> : <FaPlus />}</span>
                        <span></span>
                      </span>
                    </div>
                    <p className='mb-0'>{reminder?.referral_name}</p>
                    <p className='mb-0'>{reminder?.referral_email}</p>
                    <p className='mb-0'>{reminder?.referral_mobile}</p>
                    <div className='notesDiv my-1'>
                      <h5>Notes:</h5>
                      <p>{reminder?.notes}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : ''}

            <div className={expandedItems[data.id] ? 'expanded d-block text-start my-3 reminderMain' : 'collapsed d-block text-start my-3 reminderMain'}>
              <div className='d-flex justify-content-between reminderHeader' >
                <span>Referral Sent On</span>
                <span>
                  <span className='mx-2'> {`${new Date(
                    data?.date_added
                  ).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true
                  })}`}</span>
                  <span className='toggleIcon' onClick={() => toggleItem(data.id)}>{expandedItems[data.id] ? <FaMinus /> : <FaPlus />}</span>
                  <span></span>
                </span>
              </div>
              <p className='mb-0'>{data?.referral_name}</p>
              <p className='mb-0'>{data?.referral_email}</p>
              <p className='mb-0'>{data?.referral_mobile}</p>
              <div className='notesDiv my-1'>
                <h5>Notes:</h5>
                <p>{data?.notes}</p>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </div>
  );
};

ReminderModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object
};

const styles = {
  // overlay: {
  //   position: 'fixed',
  //   top: '0px',
  //   right: 0,
  //   backgroundColor: 'rgba(0,0,0,0.5)',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   zIndex: 999,
  //   height: '100vh',
  //   width: '100vw',
  // },
  modal: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    textAlign: 'center',
    width: '600px',
    height: '90vh',
    overflow: 'scroll',
    position: 'absolute',
    top: '50px',
    right: '10px',
    transform: 'translateY(-20px)',
    transition: '1s ease-out'

  },
  headerModal: {
    padding: '15px',
    textAlign: 'left',
    background: ' #073c4f',
    color: ' #fff',
    fontSize: '20px',
    fontWeight: '600',
    display: 'flex',
    justifyContent: 'space-between'
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px',
  },
  button: {
    padding: '10px 20px',
    borderRadius: '4px',
    margin: '10px',
    cursor: 'pointer',
    border: 'none',
  },


};

export default ReminderModal;